module.exports = __webpack_public_path__ + "img/icon_rol.bf57670f.svg";